<template>
  <div id="pageDashboard">
    <v-container
      grid-list-xl
      fluid
    >
      <v-layout
        row
        wrap
      >
        <!-- mini statistic start -->
        <v-flex
          lg3
          sm6
          xs12
        >
          <mini-statistic
            icon="fa fa-list"
            :title="dashboard.assigned"
            sub-title="My Task"
            color="indigo"
          >
          </mini-statistic>
        </v-flex>
        <v-flex
          lg3
          sm6
          xs12
        >
          <mini-statistic
            icon="fa fa-braille"
            :title="dashboard.assignedBy"
            sub-title="Assigned by Me"
            color="green"
          >
          </mini-statistic>
        </v-flex>
        <v-flex
          lg3
          sm6
          xs12
        >
          <mini-statistic
            icon="fa fa-inbox"
            :title="dashboard.inbox"
            sub-title="Total Inbox"
            color="light-blue"
          >
          </mini-statistic>
        </v-flex>
        <v-flex
          lg3
          sm6
          xs12
        >
          <mini-statistic
            icon="fa fa-exclamation-circle"
            :title="dashboard.OverDue"
            sub-title="Overdue"
            color="red"
          >
          </mini-statistic>
        </v-flex>
        <!-- mini statistic  end -->
        <!-- <v-flex
          lg8
          sm12
          xs12
        >
          <v-widget
            title="Task by Month"
            content-bg="white"
          >
            <v-btn
              icon
              slot="widget-header-action"
            >
              <v-icon class="text--secondary">refresh</v-icon>
            </v-btn>
            <div slot="widget-content">
              <e-chart
                :v-model="assignedDashboard"
                :path-option="[
                 
                  ['color', [color.lightBlue.base, color.green.lighten1]],
                  ['legend.show', true],
                  ['xAxis.axisLabel.show', true],
                  ['yAxis.axisLabel.show', true],
                  ['grid.left', '2%'],
                  ['grid.bottom', '5%'],
                  ['grid.right', '3%'],
                  ['series[0].type', 'bar'],
                  ['series[0].areaStyle', {}],
                  ['series[0].smooth', true],
                  ['series[1].smooth', true],
                  ['series[1].type', 'bar'],
                  ['series[1].areaStyle', {}],
                ]"
                height="400px"
                width="100%"
              >
              </e-chart>
            </div>
          </v-widget>
        </v-flex> -->
        <v-flex
          lg6
          sm12
          xs12
        >
          <v-widget
            title="My Task"
            content-bg="white"
          >
            <div slot="widget-content">
              <GChart
                type="ColumnChart"
                :data="chartData"
                :options="chartOptions"
                :events="chartAssignedEvents"
                ref="gChartassigned"
              />
            </div>
          </v-widget>
        </v-flex>
        <v-flex
          lg6
          sm12
          xs12
        >
          <v-widget
            title="Assigned by Me"
            content-bg="white"
          >
            <div slot="widget-content">
              <GChart
                type="ColumnChart"
                :data="chartDataAssignedBy"
                :options="chartOptions"
                :events="chartByEvents"
                ref="gChartbyMe"
              />
            </div>
          </v-widget>
        </v-flex>

        <v-flex
          lg6
          sm12
          xs12
        >
          <v-widget
            title="Task Inbox"
            content-bg="white"
          >
            <div slot="widget-content">
              <GChart
                type="ColumnChart"
                :data="chartDataInbox"
                :options="chartOptions"
                :events="chartInboxEvents"
                ref="gChartbyinbox"
              />
            </div>
          </v-widget>
        </v-flex>
        <!-- social/weather card start -->
        <!-- <v-flex lg4 sm12 xs12>
          <profile-card>
          </profile-card>
        </v-flex>         -->
        <!-- <v-flex lg4 sm12 xs12>
          <box-chart
            card-color="indigo"
            title="Trending"
            sub-title="10%"
            icon="trending_up"
            :data="siteTrafficData"
            :chart-color="[color.indigo.lighten1]"
            type="line"
          >
          </box-chart>
          <box-chart class="mt-4"
            card-color="pink"
            title="Page views"
            sub-title="10%"
            icon="trending_up"
            :data="siteTrafficData"
            :chart-color="[color.pink.darken1, 'rgba(255,255,255,0.3)']"
            gradient
            type="area"
          >
          </box-chart>          
        </v-flex> -->
        <!-- statistic section -->
        <!-- <v-flex lg4 sm12 xs12>
          <linear-statistic 
            title="Sales"
            sub-title="Sales increase"
            icon="trending_up"
            color="success"
            :value="15"
          >
          </linear-statistic>
          <linear-statistic class="my-4"
            title="Orders"
            sub-title="Increase"
            icon="trending_up"
            color="pink"
            :value="30"
          >
          </linear-statistic>          
          <linear-statistic class="my-4"
            title="Revenue"
            sub-title="Revenue increase"
            icon="trending_up"
            color="primary"
            :value="50"
          >
          </linear-statistic>          
          <linear-statistic class="mt-4"
            title="Cost"
            sub-title="Cost reduce"
            icon="trending_down"
            color="orange"
            :value="25"
          >
          </linear-statistic>          
        </v-flex> -->
        <!-- Circle statistic -->
        <!-- <v-flex
          lg4
          sm12
          xs12
          v-for="(item,index) in trending"
          :key="'c-trending'+index"
        >
          <circle-statistic
            :title="item.subheading"
            :sub-title="item.headline"
            :caption="item.caption"
            :icon="item.icon.label"
            :color="item.linear.color"
            :value="item.linear.value"
          >
          </circle-statistic>
        </v-flex> -->
        <!-- acitivity/chat widget -->
        <!-- <v-flex lg6 sm12 xs12>
          <chat-window height="308px"></chat-window>
        </v-flex> -->
        <!-- <v-flex lg6 sm12 xs12>
          <v-widget title="Activities" contentBg="white">
            <div slot="widget-content">
              <ol class="timeline timeline-activity timeline-point-sm timeline-content-right">
                <li class="timeline-block" v-for="(item, index) in activity" :key="index">
                  <div class="timeline-point">
                    <v-circle dot large :color="item.color"></v-circle>
                  </div>
                  <div class="timeline-content">
                    <time datetime="2018" class="subheading">{{item.timeString}}</time>
                    <div class="py-2 text--secondary" v-html="item.text"></div>
                  </div>
                </li>
              </ol>              
            </div>
          </v-widget>          
        </v-flex> -->
        <v-flex
          lg7
          sm12
          xs12
        >
          <!-- <task-table></task-table> -->
        </v-flex>
        <v-flex
          lg5
          sm12
          xs12
        >
          <!-- <plain-table-order></plain-table-order> -->
        </v-flex>
      </v-layout>
    </v-container>
  </div>
</template>

<script>
import API from '@/api';
import { getDashboard, getDashAssigned, getDashAssignedBy, getDashInbox } from '@/api/dashboard';
import EChart from '@/components/chart/echart';
import MiniStatistic from '@/components/widgets/statistic/MiniStatistic';
//import PostListCard from '@/components/widgets/card/PostListCard';
//import ProfileCard from '@/components/widgets/card/ProfileCard';
//import PostSingleCard from '@/components/widgets/card/PostSingleCard';
//import WeatherCard from '@/components/widgets/card/WeatherCard';
// import TaskTable from '@/components/widgets/task/TaskTable';
// import PlainTableOrder from '@/components/widgets/list/PlainTableOrder';
import VWidget from '@/components/VWidget';
import Material from 'vuetify/es5/util/colors';
import VCircle from '@/components/circle/VCircle';
import BoxChart from '@/components/widgets/chart/BoxChart';
//import ChatWindow from '@/components/chat/ChatWindow';
import CircleStatistic from '@/components/widgets/statistic/CircleStatistic';
import LinearStatistic from '@/components/widgets/statistic/LinearStatistic';
import { GChart } from 'vue-google-charts'

export default {
  components: {
    GChart,
    VWidget,
    MiniStatistic,
    //ChatWindow,
    VCircle,
    //WeatherCard,
    // PostSingleCard,
    //PostListCard,
    //ProfileCard,
    EChart,
    BoxChart,
    CircleStatistic,
    LinearStatistic,
    // TaskTable,
    // PlainTableOrder
  },
  data () {
    return {

      chartData: [
        ['', 'Unread', 'Active', 'OverDue', 'Reminder'],
        [0, 1, 1, 1, 1]
      ],
      chartDataAssignedBy: [
        ['', 'Unread', 'Active', 'OverDue'],
        [0, 1, 1, 1]
      ],
      chartDataInbox: [
        ['', 'Unread', 'OverDue'],
        [0, 1, 1]
      ],


      chartOptions: {
        chart: {
          title: 'Assinged',
          subtitle: 'Assigned to me',
        }      },

      chartAssignedEvents: {
        select: () => {

          const table = this.$refs.gChartassigned.chartObject;
          const selection = table.getSelection();
          console.log(selection);
          this.$router.push({ name: 'TaskDash', params: { id: -1 } });
        }
      },
      chartByEvents: {
        select: () => {

          const table = this.$refs.gChartbyMe.chartObject;
          const selection = table.getSelection();
          this.$router.push({ name: 'TaskDash', params: { id: -1 } });

        }
      },
      chartInboxEvents: {
        select: () => {

          const table = this.$refs.gChartinbox.chartObject;
          const selection = table.getSelection();
          console.log(selection);
          this.$router.push({ name: 'TaskDash', params: { id: -1 } });
        }
      },


      color: Material,


      dashboard: { assigned: '', assignedBy: '', inbox: '', OverDue: '' },

      option: null,
      dataset: {
        assignedDashboard: [],
        assignedbyDashboard: [['Name', 'value']],
        taskInbox: [],
      },
      userId: 1,
      // assignedDashboard: [
      // ],

      assignedbyDashboard: null,
      // taskInbox: [{ name: 'Unread', value: 8 },
      // { name: 'Active', value: 8 },
      // ],
      pieObject: { name: '', value: 0 },

    }
  },
  created () {

    this.getDashboard();
    this.getassignedDash();
  },
  mounted () {
    //this.getassignedDash()
  },

  computed: {
    activity () {
      return API.getActivity();
    },
    posts () {
      return API.getPost(3);
    },
    siteTrafficData () {
      return API.getMonthVisit;
    },
    locationData () {
      console.log(this.dataset.assignedDashboard);
      if (this.dataset.assignedDashboard.length > 0) {
        //alert('> 0')
        console.log(this.$refs.echartassigned);
        //this.$refs.echartassigned.dataset = this.dataset.assignedDashboard;
        return this.dataset.assignedDashboard;
      }
      else {

        return this.assignedbyDashboard;
      }
    }
  },
  methods: {
    getDashboard () {
      let userId = this.$store.state.auth.userId;
      getDashboard(userId)
        .then(response => {

          this.dashboard.assigned = response.data[0].totalCount
          this.dashboard.assignedBy = response.data[1].totalCount
          this.dashboard.inbox = response.data[2].totalCount
          this.dashboard.OverDue = response.data[3].totalCount
        })
        .catch(error => {
          window.getApp.$emit('APP_API_ERROR', error);
        });

      //this.getassignedDash();

    },
    getassignedDash () {
      let userId = this.$store.state.auth.userId;
      getDashAssigned(userId)
        .then(response => {

          let data = [];

          data.push(0);
          for (var prop in response.data) {

            data.push(response.data[prop].value);

          }

          this.chartData.push(data);

        })
        .catch(error => {
          window.getApp.$emit('APP_API_ERROR', error);
        });
      getDashAssignedBy(userId)
        .then(response => {
          let data = [];
          data.push(0);
          for (var prop in response.data) {
            data.push(response.data[prop].value);
          }
          this.chartDataAssignedBy.push(data);
        })
        .catch(error => {
          window.getApp.$emit('APP_API_ERROR', error);
        });

      getDashInbox(userId)
        .then(response => {
          let data = [];
          data.push(0);
          for (var prop in response.data) {
            data.push(response.data[prop].value);
          }
          this.chartDataInbox.push(data);
        })
        .catch(error => {
          window.getApp.$emit('APP_API_ERROR', error);
        });

    },

  },

};
</script>



// WEBPACK FOOTER //
// src/pages/Dashboard.vue